import { useNavigate } from 'react-router-dom';
import styles from './LandingPage.module.css';

// Логотип-надпись blot ◆ Me (брендбук: blot белый, ◆ и Me — золото)
const Wordmark = ({ className }) => (
  <span className={className}>
    <span className={styles.wmBlot}>blot</span>
    <span className={styles.wmDiamond}>◆</span>
    <span className={styles.wmMe}>Me</span>
  </span>
);

// Store-бейдж с оригинальными лого (белое яблоко / цветной треугольник Google Play)
const StoreBadge = ({ kind }) => (
  <div className={styles.badge}>
    {kind === 'apple' ? (
      <svg viewBox="0 0 384 512" className={styles.badgeLogo} aria-hidden="true">
        <path fill="#fff" d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
      </svg>
    ) : (
      <svg viewBox="0 0 96 88" className={styles.badgeLogo} aria-hidden="true">
        <polygon fill="#00D2FF" points="6,6 6,82 46,44" />
        <polygon fill="#00E676" points="6,6 46,44 84,24" />
        <polygon fill="#FF4133" points="6,82 46,44 84,64" />
        <polygon fill="#FFCE2E" points="46,44 84,24 92,44 84,64" />
      </svg>
    )}
    <span className={styles.badgeText}>
      <small>{kind === 'apple' ? 'Download on the' : 'GET IT ON'}</small>
      <b>{kind === 'apple' ? 'App Store' : 'Google Play'}</b>
    </span>
    <span className={styles.badgeSoon}>Скоро</span>
  </div>
);

const STEPS = [
  { n: '01', title: 'Заходишь по ссылке', text: 'Прямо в браузере, без установки. Мир подождёт.' },
  { n: '02', title: 'Садишься за стол', text: 'Создай свой стол или сядь к друзьям по коду.' },
  { n: '03', title: 'Включаешь видео — играешь', text: 'Голос, видео и карты — атмосфера закрытого клуба.' },
];

const LandingPage = () => {
  const navigate = useNavigate();
  const play = () => navigate('/app');

  return (
    <div className={styles.page}>
      {/* Прокуренный фон-силуэты (под blur'ом, еле заметно) */}
      <div className={styles.ambient} style={{ backgroundImage: 'url(/images/landing/club.jpg)' }} />
      <div className={styles.ambientFade} />

      {/* ===== Навигация ===== */}
      <nav className={styles.nav}>
        <Wordmark className={styles.navLogo} />
        <div className={styles.navLinks}>
          <a href="#features">Возможности</a>
          <a href="#how">Как играть</a>
          <a href="#download">Скачать</a>
        </div>
        <button className={styles.navCta} onClick={play}>Играть в браузере</button>
      </nav>

      {/* ===== Hero (двухколоночный, база C: текст слева + телефоны справа) ===== */}
      <header className={styles.hero}>
        <div className={styles.heroText}>
          <div className={styles.lockup}>
            <Wordmark className={styles.heroTitle} />
            <div className={styles.heroSlogan}>THE WORLD CAN WAIT</div>
          </div>
          <div className={styles.heroActions}>
            <button className={styles.primaryCta} onClick={play}>
              <span className="material-symbols-outlined">play_arrow</span>
              Играть в браузере
            </button>
          </div>
          <ul className={styles.promo}>
            <li>Базар блот с живой видеосвязью</li>
            <li>Видео-столы вживую — голос и видео за столом</li>
            <li>Честная раздача — проверяемая (verifiable shuffle)</li>
            <li>Рейтинг, лиги и кубки недели</li>
            <li>Друзья и приватные столы для своих</li>
          </ul>
        </div>

        <div className={styles.heroMockups}>
          <div className={`${styles.phone} ${styles.phoneBack}`}>
            <img src="/images/landing/room-2.png" alt="Игровой стол BlotMe" />
          </div>
          <div className={`${styles.phone} ${styles.phoneFront}`}>
            <img src="/images/landing/room-1.png" alt="Игровой стол BlotMe" />
          </div>
        </div>
      </header>

      {/* ===== Возможности — bento (база C, реальные столы) ===== */}
      <section id="features" className={styles.section}>
        <div className={styles.diamondDivider}><span>◆</span></div>
        <h2 className={styles.h2center}>Безупречный опыт</h2>
        <p className={styles.sectionSub}>Продуманный до мелочей — для тех, кто ценит игру.</p>
        <div className={styles.bento}>
          <div className={`${styles.bentoCard} ${styles.bentoWide}`}>
            <div className={styles.bentoBody}>
              <span className={`material-symbols-outlined ${styles.bentoIcon}`}>videocam</span>
              <h3 className={styles.featureTitle}>Видео-столы вживую</h3>
              <p className={styles.muted}>
                Видишь и слышишь соперников в реальном времени — эффект присутствия за одним столом,
                без потери приватности.
              </p>
            </div>
            <div className={styles.bentoImg}><img src="/images/landing/room-2.png" alt="Видео-стол BlotMe" /></div>
          </div>

          <div className={styles.bentoCard}>
            <span className={`material-symbols-outlined ${styles.bentoIcon}`}>shield</span>
            <h3 className={styles.featureTitle}>Приватные столы</h3>
            <p className={styles.muted}>Закрытые игры только для своих — полный контроль над доступом и столом.</p>
          </div>

          <div className={styles.bentoCard}>
            <span className={`material-symbols-outlined ${styles.bentoIcon}`}>workspace_premium</span>
            <h3 className={styles.featureTitle}>Рейтинг и лиги</h3>
            <p className={styles.muted}>От Новичка до Гроссмейстера — закрытые турниры и статусы для постоянных.</p>
          </div>

          <div className={`${styles.bentoCard} ${styles.bentoWide} ${styles.bentoReverse}`}>
            <div className={styles.bentoImg}><img src="/images/landing/room-1.png" alt="Игровой стол BlotMe" /></div>
            <div className={styles.bentoBody}>
              <span className={`material-symbols-outlined ${styles.bentoIcon}`}>verified_user</span>
              <h3 className={styles.featureTitle}>Честная раздача</h3>
              <p className={styles.muted}>
                Проверяемая раздача (verifiable shuffle) и плавная механика классического блота —
                никаких подкрученных карт.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== Как играть ===== */}
      <section id="how" className={styles.section}>
        <div className={styles.diamondDivider}><span>◆</span></div>
        <h2 className={styles.h2center}>Как начать</h2>
        <div className={styles.steps}>
          {STEPS.map((s) => (
            <div key={s.n} className={styles.step}>
              <div className={styles.stepNum}>{s.n}</div>
              <h3 className={styles.featureTitle}>{s.title}</h3>
              <p className={styles.muted}>{s.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ===== Скачать ===== */}
      <section id="download" className={styles.download}>
        <h2 className={styles.h2center}>Скоро в сторах</h2>
        <p className={styles.muted} style={{ textAlign: 'center' }}>А пока — играй прямо в браузере.</p>
        <div className={styles.downloadActions}>
          <button className={styles.primaryCta} onClick={play}>
            <span className="material-symbols-outlined">play_arrow</span>
            Играть в браузере
          </button>
        </div>
        <div className={styles.badges}>
          <StoreBadge kind="apple" />
          <StoreBadge kind="google" />
        </div>
      </section>

      {/* ===== Футер ===== */}
      <footer className={styles.footer}>
        <Wordmark className={styles.footerLogo} />
        <div className={styles.footerLinks}>
          <a href="/terms">Условия</a>
          <a href="/privacy">Конфиденциальность</a>
          {/* Отказаться от сбора данных можно в любой момент — открывает тот же баннер */}
          <a
            href="#privacy"
            onClick={(e) => { e.preventDefault(); window.dispatchEvent(new Event('blotme:privacy')); }}
          >
            Твои данные
          </a>
          <a href="/delete-account">Удалить аккаунт</a>
          <a href="mailto:support@blotme.app">Контакты</a>
        </div>
        <div className={styles.footerCopy}>© AI Industries LLC</div>
      </footer>
    </div>
  );
};

export default LandingPage;
